<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="goBackToList($event)"> </app-breadcrumb>
    <div class="container-fluid">
      <app-owner-overview (profileDetailsEvent)="getUserDetails($event)"></app-owner-overview>
  
      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="card">       
         <div class="card-header-line">
             <div class="row m-2" *ngIf="userProperties?.length">
            <div class="col-md-6">                
                 <select class="form-control width320" (change)="getPropertyInvoices()" [(ngModel)]="choosenProperty">
                    <option value="" selected disabled>Select Property</option>
                    <option *ngFor="let property of userProperties" [value]="property.uid">
                         {{property.name }} 
                    </option>
                 </select>
                 </div>
                <div class="col-md-6">
                    <a *ngIf="currentLease" class="badge badge-success me-2 mt-2 float-end c-pointer" (click)="changeLeases()">Previous
                        Leases</a>
                    <a *ngIf="!currentLease" class="badge badge-success me-2 mt-2 float-end c-pointer" (click)="changeLeases()">Current
                        Lease</a>
                </div>
        </div>
        </div>
        <div class="row">
            <div class="col-xl-12">
            <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper" *ngIf="ownerInvoices?.length">  
                <table matSort (matSortChange)="sortData($event)" id="empoloyees-tbl" class="table mb-0">
                    <thead>
                        <tr>                          
                            <th>Lease/Rent Amount</th>
                            <th>Security Deposit</th>
                            <th>Lease Start Date</th>
                            <th>Lease End Date</th>
                            <th>Agreement Date</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(item of ownerInvoices; track item){
                        <tr>                           
                            <td>{{ item.lease_amount }}</td>
                            <td>
                                <span>{{ item.security_deposit }}</span>
                            </td>
                            <td>
                                <span>{{ item.start_date | date:'dd-MM-yyyy' }}</span>
                            </td>
                            <td>
                                <span>{{ item.end_date | date:'dd-MM-yyyy' }}</span>
                            </td>
                            <td>
                                <span>{{ item.agreement_date | date:'dd-MM-yyyy' }}</span>
                            </td>
                            <td class="text-center">
                                <button type="button"
                                  class="btn btn-success shadow btn-xs sharp me-1 mb-1" (click)="viewImage(item.document_url)"><i class="fa fa-eye"></i>
                                </button>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>                
            </div>
            <p class="text-center mt-2 no-docs" *ngIf="!ownerInvoices?.length">No invoices found</p>
        </div>
    </div>
</div>
        </div>
    </div>
</div>

